// import asyncSessionLoader from "../../../../../core/gd/data/async-session-loader"
// import {ViewType} from "../../../../../core/gd/const/views/view-type"
// import quickAdd_createPageDocument from "./create-page-document"
import ApiProject from "../../../../../../core/gd/api/project"
import asyncSessionLoader from "../../../../../../core/gd/data/async-session-loader"

type APICallParams = {
    company         : ID
    parentProject?  : ID
    name            : string
    owner?          : string
    color?          : number
    projectIcon?    : string
}

const debug = false
// const debug = 'quickAdd_createPage'

export default async function quickAdd_createPage(params: APICallParams) {

    await asyncSessionLoader(gd.session.findMissing({
        // @ts-ignore
        projectsSettings: [params.parentProject, ...gd.session.projects.getAllParentsIds(params.parentProject)]
    }))

    // create project for Page
    const data = await ApiProject.newPage({
        parentProjectId : params.parentProject,
        name            : params.name,
        color           : params.color,
        isTemplate      : false,
        projectIcon     : params.projectIcon
    }).promise()

    /*// set proper icon for Page project
    await gd.api.Project.update(data.projectId, {projectIcon:'taskList'}).promise()

    // load settings of just created project
    await asyncSessionLoader(gd.session.findMissing({
        projectsSettings: [data.projectId],
    }))

    const document = await quickAdd_createPageDocument(data.projectId)
    const project = gd.session.projects.get(data.projectId)

    // create page view linked to previously created document
    project.settings.views = [{
        id          : document.id,
        // userId      : gd.user.id,
        isPinned    : true,
        documentId  : document.id,
        systemType  : ViewType.PROJECT_PAGE
    }]
    project.settings.defaultView = document.id
    project.settings.save()*/

    const project = gd.session.projects.get(data.projectId)!
    debug && console.log(debug, 'onSubmit project', project.settings)

    return project
}